import { connect } from 'react-redux';
import { compose, lifecycle, withProps, withHandlers } from 'recompose';
import { pick } from 'ramda';

import { withRouter } from 'react-router';

import withNewDesignStyles from '../../../../../common/hoc/withNewDesignStyles';
import withNotifications from '../../../../../common/withNotifications';
import withLoading from '../../../../../common/withLoading';
import confirmModal from '../../../../../common/confirmModal';
import EditCustomReport from './EditCustomReport';
import { getUserUrlPrefix } from '../../../../../auth/selectors';
import {
  getMetricsDefinitions,
  isMetricsDefinitionsFetched,
  getReportDefinitionById,
} from '../../selectors';
import {
  fetchMetricsDefinitions,
  fetchReportDefinition,
  updateCustomReport,
  deleteCustomReport,
} from '../../actions';
import {
  getApiReportFromFormValues,
  getCustomReportLink,
} from '../../utils';
import form from './formConfig';

const EditCustomReportContainer = compose(
  withNewDesignStyles,
  withRouter,
  withNotifications,
  connect(
    (state, ownProps) => ({
      item: getReportDefinitionById(state, ownProps.params.id),
      metricsDefinitions: getMetricsDefinitions(state),
      fetchedFields: isMetricsDefinitionsFetched(state),
      urlPrefix: getUserUrlPrefix(state),
    }),
    {
      fetchMetricsDefinitions,
      fetchReportDefinition,
      updateCustomReport,
      deleteCustomReport,
    }
  ),
  withProps(props => ({
    title: 'Edit Custom Report',
    canDelete: true,
    showLoading: !props.fetchedFields || !props.item,
    backLink: props.item ? getCustomReportLink(props.item) : '/reports',
    initialValues: props.item ? pick(['name', 'type'], props.item) : {},
  })),
  withHandlers({
    onSubmit: props => async (values) => {
      const confirmed = await confirmModal({
        type: 'defaultSafe',
        title: 'Save report template',
        message: 'This action will override the initial template.\n\nAre you sure you want to proceed?',
        confirmButtonText: 'Save template',
        negativeButtonText: 'Cancel',
      });

      if (!confirmed) {
        return false;
      }

      return props.updateCustomReport(
        props.item.id,
        getApiReportFromFormValues(values)
      );
    },
    handleDelete: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Delete report template',
        message: 'This action will permanently delete your report template.\n\nAre you sure you want to proceed?',
        confirmButtonText: 'Delete Report',
        negativeButtonText: 'Cancel',
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteCustomReport(props.item.id)
        .then(() => {
          props.router.replace('/reports');
          props.addNotification({
            level: 'success',
            message: 'Report template is deleted.',
            title: 'Success',
          });
        })
        .catch(() => {
          props.router.replace('/reports');
        });
    },
  }),
  form,
  withHandlers({
    setReportMetrics: props => (reportMetrics) => {
      props.change('reportMetrics', reportMetrics);
    },
  }),
  lifecycle({
    componentWillMount() {
      this.props.fetchMetricsDefinitions();

      if (!this.props.item) {
        this.props.fetchReportDefinition(this.props.params.id);
      }
    },
  }),
  withLoading,
)(EditCustomReport);

export default EditCustomReportContainer;
